/**
 * Campaign Countdown Timer
 * Finds [data-campaign-end] elements and ticks down to the end time.
 * Removes the countdown element when the campaign has ended.
 */
(function() {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initCountdown(el) {
    if (el.dataset.countdownInit === 'true') return;
    el.dataset.countdownInit = 'true';

    var endTime = new Date(el.dataset.campaignEnd).getTime();
    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minutesEl = el.querySelector('[data-countdown-minutes]');
    var secondsEl = el.querySelector('[data-countdown-seconds]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    function tick() {
      var now = Date.now();
      var diff = endTime - now;

      if (diff <= 0) {
        el.remove();
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);

      requestAnimationFrame(function() {
        setTimeout(tick, 1000 - (Date.now() % 1000));
      });
    }

    tick();
  }

  function checkForCountdowns() {
    var els = document.querySelectorAll('[data-campaign-end]');
    els.forEach(function(el) {
      if (el.dataset.countdownInit !== 'true') {
        initCountdown(el);
      }
    });
  }

  checkForCountdowns();
  var pollInterval = setInterval(checkForCountdowns, 500);
  setTimeout(function() {
    clearInterval(pollInterval);
  }, 30000);

  document.addEventListener('cart:update', function() {
    setTimeout(checkForCountdowns, 100);
  });
})();
